import { Link, NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const menu = [
  { name: "Dashboard", path: "/admin/dashboard", icon: "📊" },
  { name: "Products CMS", path: "/admin/productslist", icon: "📦" },
  { name: "Gallery CMS", path: "/admin/gallerylist", icon: "🖼️" },
  // { name: "Industry Section", path: "/admin/industriescms", icon: "🏠" },
  { name: "Client Section", path: "/admin/clientscms", icon: "🏠" },
  { name: "Testimonial Section", path: "/admin/testimonialscms", icon: "💬" },
  { name: "Contact Page", path: "/admin/contactcms", icon: "💬" },
  { name: "Logout", path: "/login", icon: "↩", logout: true },
];

export default function Sidebar({ mobile = false, closeSidebar }) {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear tokens or user info if needed
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    setShowLogoutModal(false);
    navigate("/login");
    if (closeSidebar) closeSidebar();
  };

  return (
    <>
      <aside
        className={`
          bg-gray-600 text-white flex flex-col
          ${mobile ? "w-screen h-full" : "w-64 hidden md:flex"}
        `}
      >
        {/* TOP BAR (LOGO + CLOSE BUTTON FOR MOBILE) */}
        <div className="flex items-center justify-between p-4 py-1 border-b border-white/10">
          <Link to="/admin/dashboard" onClick={closeSidebar}>
            <img
              src="/images/logo/sera-logo.png"
              className="h-14 object-cover"
              alt="Sera Water Logo"
            />
          </Link>

          {/* CLOSE BUTTON (MOBILE ONLY) */}
          {mobile && (
            <button
              onClick={closeSidebar}
              className="text-white text-2xl md:hidden"
              aria-label="Close sidebar"
            >
              <FontAwesomeIcon icon={faXmark} className="icon" />
            </button>
          )}
        </div>

        {/* MENU */}
        <nav className="flex-1 p-4 py-0 space-y-2 overflow-y-auto no-scrollbar">
          {menu.map((item, i) =>
            item.logout ? (
              <button
                key={i}
                onClick={() => setShowLogoutModal(true)}
                className="flex items-center gap-3 px-4 py-3 rounded transition w-full text-left hover:bg-white/10"
              >
                <span>{item.icon}</span>
                {item.name}
              </button>
            ) : (
              <NavLink
                key={i}
                to={item.path}
                onClick={closeSidebar}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded transition
                   ${
                     isActive
                       ? "bg-primary text-dark font-semibold"
                       : "hover:bg-white/10"
                   }`
                }
              >
                <span>{item.icon}</span>
                {item.name}
              </NavLink>
            )
          )}
        </nav>
      </aside>

      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
          <div className="bg-white rounded-2xl p-6 shadow-2xl w-full max-w-sm relative z-10 transform transition-all animate-in fade-in zoom-in duration-200">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
                <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600 text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Confirm Logout</h3>
              <p className="text-gray-500 mb-8">
                Are you sure you want to logout? You will need to login again to access the panel.
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowLogoutModal(false)}
                  className="flex-1 px-4 py-2.5 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleLogout}
                  className="flex-1 px-4 py-2.5 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 shadow-lg shadow-red-200 transition"
                >
                  Yes, Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
